// Estilos compartidos de Recharts para que todos los gráficos lean como un sistema.
//
// Los colores van como `var(--c-…)` y NO como hex: así el gráfico cambia de tema
// junto con el resto de la app sin re-montarse ni recalcular nada en JS. Los
// atributos de presentación de SVG aceptan var() igual que el CSS.
const c = (nombre: string, alfa?: number) =>
  alfa === undefined ? `rgb(var(--c-${nombre}))` : `rgb(var(--c-${nombre}) / ${alfa})`;

export const CHART = {
  grid: c('hairline'),
  axis: c('ink-faint'),
  axisFont: 11,
  base: c('primary-text'),
  band: c('primary', 0.16),
  historical: c('ink-ghost'),
  optimistic: c('success-text'),
  pessimistic: c('danger-text'),
  target: c('violet-text'),
  bar: c('danger'),
  success: c('success'),
  fontFamily: '"IBM Plex Sans", system-ui, sans-serif',
};

export const tooltipStyle = {
  background: c('card'),
  border: `1px solid ${c('hairline')}`,
  borderRadius: 10,
  fontSize: 12,
  color: c('ink-strong'),
  boxShadow: 'var(--sombra-alta)',
} as const;
